module.exports = __webpack_public_path__ + "img/mobile-9.68eb4fa3.png";